import {Component, ElementRef, ViewChild} from '@angular/core';
import {AbstractDialogComponent} from '@wba-ui-module/components/dialogs/abstract-dialog.component';
import {Modal} from 'bootstrap';
@Component({
    selector: 'wba-ios-download-dialog',
    templateUrl: './ios-download-dialog.component.html',
    styleUrls: ['./ios-download-dialog.component.scss'],
    standalone: false
})
export class IosDownloadDialogComponent extends AbstractDialogComponent {

  @ViewChild('modalDialogEl') modalDialogEl: ElementRef;
  @ViewChild('anchorElement') anchorElement: ElementRef;

  constructor() {
    super();
  }

  static open() {
    (new Modal(document.getElementById('IosDownloadModal'))).show();
  }
}
